<template>
  <a-modal :width="1500" title="客户自费对账" v-model="customerReconciliationible" footer="">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form2">
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="订单号" style="margin-left: 45px">
              <a-input v-model.trim="queryParam.orderNo" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
              <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                <a-select-option v-for="type in installTypes" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
              <a-select v-model="queryParam.orderType" @change="getorderStatus" :allowClear="true">
                <a-select-option v-for="type in List" :key="type.orderTypeId">{{ type.typeName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="客户自费收款状态">
              <a-select v-model="queryParam.receiveMoneyStatus" :allowClear="true">
                <a-select-option v-for="type in receive_money_status" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="客户姓名" style="margin-left: 30px">
              <a-input v-model.trim="queryParam.customerName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="客户联系方式">
              <a-input v-model.trim="queryParam.customerMobile" />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-row :gutter="24" style="margin-left: 0px">
              <a-form-item label="客户地址" style="margin-left: 30px">
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.province" @change="getselect" :allowClear="true">
                    <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">{{
                      type.provinceName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.city" @change="getprovinceName" :allowClear="true">
                    <a-select-option v-for="type in selectCityName" :key="type.cityCode">{{
                      type.cityName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.area" :allowClear="true">
                    <a-select-option v-for="type in selectAreaName" :key="type.areaCode">{{
                      type.areaName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="9" :sm="24">
                  <a-input v-model.trim="queryParam.address" />
                </a-col>
              </a-form-item>
            </a-row>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="账单号" style="margin-left: 45px">
              <a-input v-model.trim="queryParam.statementNo" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="账单名" style="margin-left: 45px">
              <a-input v-model.trim="queryParam.statementName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="品牌" style="margin-left: 60px">
              <a-select showSearch optionFilterProp="children" :filterOption="filterOption" v-model="queryParam.brand">
                <a-select-option v-for="type in selectBrand" :key="type.brandId">{{ type.brandName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="型号" style="margin-left: 60px">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changeModelName"
                :filterOption="filterOption"
                v-model="queryParam.model"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectModel" :key="type.modelId">{{ type.modelName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="购买渠道" style="margin-left: 30px">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changesourceName"
                :filterOption="filterOption"
                v-model="queryParam.buyChannel"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectChannel" :key="type.channelId"
                  >{{ type.channelName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单完成时间">
              <a-range-picker
                style="width: 100%"
                v-model="completeTime"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
                @change="onChangecompleteOrder"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="建单时间" style="margin-left: 30px">
              <a-range-picker
                style="width: 100%"
                v-model="createTime"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
                @change="onChangecreateOrde"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <!--        筛选的条件-->
        <!--        查询和清空按钮-->
        <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
            <a-col :span="15"></a-col>
            <a-col :span="8" :style="{ textAlign: 'right' }">
              <!--              查询功能待完善 只能查询公司名-->
              <a-button type="primary" htmlType="submit" @click="query">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty">清空</a-button>
              <a-button style="margin-left: 8px" type="primary" v-if="exportOrderCustomerStatement" @click="exportEnt()"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>
        </span>
      </a-form>
    </div>
    <!--   江苏锁安科技有限公司 2020年2月对帐单  表头-->
    <a-row v-if="editList">
      <a-col :span="21">
        <h1 style="text-align: center">江苏锁安科技有限公司 2020年2月对帐单{{ editList.majorStatementName }}</h1>
        <h4 style="text-align: center">市场负责人：{{ editList.marketPrincipal }}</h4>
      </a-col>
    </a-row>
    <!--    第二个单选框-->
    <a-row v-if="editList">
      <a-col :span="19">
        <a-row>
          <a-col :span="5"> </a-col>
          <a-col :span="6">
            <span style="font-weight: bold; font-size: 20px; margin-right: 10px; line-height: 30px">{{
              editList.subStatementName
            }}</span>
            <span style="font-size: 16px; line-height: 30px">截止至{{ editList.closingDate }}</span>
          </a-col>
          <a-col :span="10" style="margin-top: 5px">
            <a-checkbox @change="onChangeSettleComplete"> 不显示已结算订单 </a-checkbox>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row v-if="editList">
      <a-col :span="19" style="margin: 10px 0">
        <a-row>
          <a-col :span="5"> </a-col>
          <a-col :span="6">
            <span style="font-size: 14px; line-height: 30px; font-weight: 700">账单号：{{ editList.statementNo }}</span>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <div style="margin-bottom: 16px"></div>
    <!--        表格内容-->
    <a-table
      v-if="editList"
      size="default"
      ref="table"
      :columns="columns"
      :dataSource="editList.orders"
      bordered
      :scroll="{ x: 3000 }"
    >
      <span slot="action" slot-scope="text, record">
        <a v-if="select" @click="orderdetailsView(record)">查看</a>
        <a-divider
          type="vertical"
          v-if="(editCustomerReconciliation && editList.statementStatus == 1) || editList.statementStatus == 4"
        />
        <a
          v-if="(editCustomerReconciliation && editList.statementStatus == 1) || editList.statementStatus == 4"
          @click="modify(record)"
          >修改</a
        >
      </span>
      <span slot="updateAmount" slot-scope="text, record">
        <a-popover title="修改备注">
          <template slot="content">
            <div style="overflow-y: auto; max-height: 450px; padding-right: 20px" v-if="record.orderUpdateRemark">
              <span v-for="tab in record.orderUpdateRemark.split('/$/')"
                ><span>{{ tab }}</span>
                <br />
              </span>
            </div>
          </template>
          <a type="primary">
            <span v-if="record.updateAmount > 0" class="classYellow">{{ record.updateAmount }}</span>
            <span v-else>{{ record.updateAmount }}</span>
          </a>
        </a-popover>
      </span>
    </a-table>
    <!--    最后字段-->
    <a-row v-if="editList">
      <a-col :span="19" style="margin: 10px 0">
        <a-row>
          <a-col :span="5"> </a-col>
          <a-col :span="19" style="text-align: center">
            <span style="font-size: 14px; font-weight: 700; text-align: center"
              >总金额：{{ editList.enterpriseTotalAmount }}元 结算金额：{{ editList.enterpriseSettleAmount }}元
              已结算金额：{{ editList.alreadySettleAmount }}元 实际需结算：{{ editList.needSettleAmount }}元
              订单总计：{{ editList.orderNum }}单
            </span>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <!--    最后的按钮-->
    <a-row v-if="editList">
      <a-col :span="19" style="margin: 10px 0">
        <a-row>
          <a-col :span="5"> </a-col>
          <a-col :span="19" style="text-align: center; margin: 20px 0">
            <a-button
              type="primary"
              style="margin-left: 8px"
              v-if="(submitCustomerReconciliation && editList.statementStatus == 1) || editList.statementStatus == 4"
              @click="submitStatement"
              >提交对帐单</a-button
            >
            <a-button style="margin-left: 8px" @click="goone()">返回</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <!--    结算完成的弹框-->
    <a-modal
      title="修改"
      style="top: 20px"
      :width="800"
      v-model="modifyible"
      :confirmLoading="confirmLoading"
      @ok="EnterpriseOk"
      @cancel="handleCancel"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算金额">
          <a-input v-model="settleAmount" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="修改后金额">
          <a-input v-model="modifiedAmount" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="反馈">
          <a-input type="textarea" v-model="feedback" />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 使用弹框组件-->
    <!--<Enterprise-modal ref="modal" @ok="handleOk"/>-->
    <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
    <edit-order-model1 v-else ref="editorder"></edit-order-model1>
  </a-modal>
</template>
<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
import { getfinddictAll } from '@/api/order/orderList'
import { getDataTemplate } from '@/api/finance/enterpriseSingle'
import { STable } from '@/components'
import { getselectSource, getselectChannel } from '@/api/order/NewlyaddedOrderList'
import {
  getList,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getmarketPrincipal,
  getSelectBrand,
  getOrderDetail,
  getSelectModel,
  getfindByDeptId,
} from '@/api/order/orderList'
import { getUpdateAmount, getEnterpriseSubmit } from '@/api/finance/customerReconciliation'
import { getSubStatementDetailList } from '@/api/finance/customerList'
import EnterpriseModal from '../modules/EnterpriseModal.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../../utils/dict'
const options = [{ label: '不显示已结算订单', value: '不显示已结算订单' }]
export default {
  name: 'customerReconciliation',
  components: {
    STable,
    // 注册弹框组件
    EnterpriseModal,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
  },
  data() {
    return {
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      List: [],
      selectBrand: [],
      selectModel: [],
      selectSource: [],
      selectChannel: [],
      form2: this.$form.createForm(this),
      receive_money_status: [],
      // 控制修改弹框
      modifyible: false,
      completeTime: '',
      createTime: '',
      confirmLoading: false,
      // 结算金额
      settleAmount: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      // 修改后金额
      modifiedAmount: '',
      feedback: '',
      // 编辑带过来的数据
      editList: '',
      loading: false,
      customerReconciliationible: false,
      form: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
        },
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      options,
      value2: '不显示已结算订单',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      // 字典为安装类型
      installTypes: [],
      // 字典为分单方式
      plainOptions: [],
      seperate_order_method: [],
      select: checkPermission('order:list:select'),
      editCustomerReconciliation: checkPermission('editCustomerReconciliation'),
      exportOrderCustomerStatement: checkPermission('exportOrderCustomerStatement'),
      submitCustomerReconciliation: checkPermission('submitCustomerReconciliation'),
      subStatementId: '',
    }
  },
  filters: {},
  // 下拉框的选项
  async created() {},
  // 计算选中的数据条数
  computed: {},
  methods: {
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    exportEnt() {
      this.queryParam.statementId = this.subStatementId
      var str = process.env.VUE_APP_API_BASE_URL + '/finance/customerStatement/subDetailExport?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      console.log(str)
      window.open(str)
    },
    onChangeSettleComplete(e) {
      if (e.target.checked) {
        this.queryParam.notShowSettleComplete = 1
      } else {
        this.queryParam.notShowSettleComplete = ''
      }
      this.query()
    },
    async showcreated() {
      this.empty()
      this.selectChannel = []
      // 查询信息来源下拉框
      await getselectChannel().then((res) => {
        if (res.code === 0) {
          // console.log(res)
          this.selectChannel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectSource = []
      // 查询信息来源下拉框
      await getselectSource().then((res) => {
        if (res.code === 0) {
          // console.log(res)
          this.selectSource = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectBrand = []
      await getSelectBrand().then((res) => {
        if (res.code === 0) {
          this.selectBrand = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectModel = []
      await getSelectModel().then((res) => {
        if (res.code === 0) {
          this.selectModel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      await getselectAllProvince().then((res) => {
        if (res.code === 0) {
          // console.log(res)
          this.selectAllProvince = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })

      let dictTypes = ['install_type', 'receive_money_status']
      getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
        this.installTypes = res.install_type
        this.receive_money_status = res.receive_money_status
      })
    },
    empty() {
      this.queryParam = {}
      this.completeTime = ''
      this.createTime = ''
      this.form2.resetFields()
    },
    moment,
    showCustomerReconciliation(id) {
      this.subStatementId = id
      this.showcreated()
      this.customerReconciliationible = true
      getSubStatementDetailList({ statementId: id }).then((res) => {
        if (res.code === 0) {
          this.editList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })

      getDataTemplate({ statementId: id, statementOwnerType: 1, statementType: 1 }).then((res) => {
        if (res.code === 0) {
          // console.log(res)
          // for(let col of res.data) {
          //   if (col.dataIndex == "settleAmount")
          //     col['scopedSlots'] = { customRender: 'money' }
          // }
          for (let col of res.data) {
            col['align'] = 'center'
            if (col.dataIndex == 'updateAmount') col['scopedSlots'] = { customRender: 'updateAmount' }
          }
          this.columns = [
            {
              title: '序号',
              customRender: (text, record, index) => `${index + 1}`,
              align: 'center',
            },
            {
              title: '操作栏',

              dataIndex: 'action',
              scopedSlots: { customRender: 'action' },
            },
          ]
          this.columns = [...this.columns, ...res.data]
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    query() {
      this.queryParam.statementId = this.subStatementId
      getSubStatementDetailList(this.queryParam).then((res) => {
        if (res.code === 0) {
          this.editList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    orderdetailsView(record) {
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(record.orderId, '', 0)
      })
      // this.$refs.editorder.showeditOrder()
    },
    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onChangecreateOrde(date, dateString) {
      this.queryParam.createOrderTimeBegin = dateString[0]
      this.queryParam.createOrderTimeEnd = dateString[1]
    },
    onChangecompleteOrder(date, dateString) {
      this.queryParam.orderCompleteTimeBegin = dateString[0]
      this.queryParam.orderCompleteTimeEnd = dateString[1]
    },
    installChange9(e) {
      this.queryParam.orderType = e
    },
    async installChange(e) {
      this.form2.setFieldsValue({
        orderType9: '',
      })
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 修改
    modify(record) {
      this.modifyible = true
      this.settleAmount = record.settleAmount
      this.orderId = record.orderId
    },
    // 修改取消时调用的方法
    handleCancel() {
      this.modifyible = false
    },
    refreshEditList() {
      this.$emit('ok')
      getSubStatementDetailList({ statementId: this.subStatementId }).then((res) => {
        if (res.code === 0) {
          this.editList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.$message.success('操作成功')
    },
    // 修改确定时调用的方法
    async EnterpriseOk() {
      this.modifyible = false
      this.confirmLoading = false
      await getUpdateAmount({
        newAmount: this.modifiedAmount,
        oldAmount: this.settleAmount,
        orderId: this.orderId,
        subStatementId: this.subStatementId,
        remark: this.feedback,
      }).then((res) => {
        if (res.code === 0) {
          this.refreshEditList()
        } else {
          this.$message.error(res.msg)
        }
      })
      this.modifiedAmount = ''
      this.settleAmount = ''
      this.feedback = ''
    },
    // 提交对账单 userName='admin' {subStatementId:this.editList.subStatementId}
    submitStatement() {
      getEnterpriseSubmit({ subStatementId: this.subStatementId }).then((res) => {
        if (res.code === 0) {
          this.$emit('ok')
          this.customerReconciliationible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    goone() {
      this.customerReconciliationible = false
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    // 点按钮生成对账单
    handleremark(record) {
      this.$refs.modal.remark(record)
      console.log(record)
    },
  },
  watch: {},
}
</script>
<style scoped>
/deep/ .clickRowStyleOrange {
  background: #ffbb77;
}
/deep/ .clickRowStyle {
  background: #ff7575;
}

/deep/ .clickRowStyle3 {
  background: #f9ff9f;
}
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
/deep/ .classYellow {
  background-color: #ffe168;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>


